import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer';
import MapView from '@arcgis/core/views/MapView';
import { Tool, ToolSlot } from 'cd-eft/components/Design/BreaklineTools/framework/Tool';
import { SurfaceDef } from 'cd-eft/components/Design/BreaklineTools/model/SurfaceDef';
import { GroundPoint } from '../model/GroundPoint';
import { SurfaceBorder } from '../model/SurfaceBorder';
import { PickBorderPointInputTask } from './PickBorderPointInputTask';
import stores from '../../../../models/Stores';

const setStore = stores.AppStore.surveyEngineeringStore;

export class DeleteBorderPointTool extends Tool {
  private readonly mapView: MapView;
  private readonly surfaceDef: SurfaceDef;
  private task: PickBorderPointInputTask;
  private borderLayer: GraphicsLayer;

  constructor(mapView: MapView, surfaceDef: SurfaceDef, toolSlot: ToolSlot, borderLayer: GraphicsLayer) {
    super('Delete Border Point', 'continuous', toolSlot);
    this.mapView = mapView;
    this.surfaceDef = surfaceDef;
    this.task = new PickBorderPointInputTask(this.mapView, this.surfaceDef);
    this.borderLayer = borderLayer;
  }

  protected async onExecuteOperation(): Promise<void> {
    if (this.surfaceDef.border.borderPoints.length <= 3) {
      throw new Error('Invalid operation: cannot use this tool if border has 3 or fewer points.');
    }

    super.onExecuteOperation();

    const result = await this.task.executeTaskAsync();

    const index = this.surfaceDef.border.borderPoints.indexOf(result);
    if (index >= 0) {
      // this.surfaceDef.border.borderPoints.splice(index, 1); // old logic

      // new logic:  replace the entire border object, do not modify inline point collection of original border object
      const newBorder = new SurfaceBorder();
      newBorder.wkid = this.surfaceDef.border.wkid;
      newBorder.borderPoints.push(...this.surfaceDef.border.borderPoints);
      newBorder.borderPoints.splice(index, 1);
      this.surfaceDef.border = newBorder;
      if (this.surfaceDef.isCurrentIdentiticalToOriginalBorder()) {
        this.surfaceDef.clearBorderSyncStatus();
      }
    }

    //redraw layer
    this.borderLayer.removeAll();
    const graphic = this.surfaceDef.border.generatePolygonGraphic(this.mapView.spatialReference);
    this.borderLayer.add(graphic);

    // this.surfaceDef.findGoundPointsTinnableModifiedByBorder(this.surfaceDef.border.generatePolygonGeometry());
    this.surfaceDef.applyBorderOnSurveyEditables(this.surfaceDef.border.generatePolygonGeometry(), this.surfaceDef.border.generatePolylineGeometry());
    setStore.triggerSurfaceDesignerVm?.drawSurveyPoints();
    setStore.triggerBreaklineToolboxVM?.drawGroundPoints();

    return;
  }

  protected async onCancelOperation(): Promise<void> {
    if (this.task.isExecuting) {
      await this.task.cancelTaskAsync();
    }
    return;
  }
}
